import React from "react";
import { ACTIVE_PRIMARY, WHITE } from "@/constants/colors";

const InfoIcon = ({ color = WHITE, backgroundColor = ACTIVE_PRIMARY }) => (
  <svg
    version="1.2"
    overflow="visible"
    preserveAspectRatio="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    height="24"
    width="24"
  >
    <rect
      height="24"
      width="24"
      fillRule="nonzero"
      fill={backgroundColor}
      y="0"
      x="0"
      id="Rectangle-background"
      rx="2"
      ry="2"
    />
    <rect
      height="2"
      width="2"
      fillRule="nonzero"
      fill={color}
      y="5"
      x="11"
      id="Rectangle-1"
    />
    <rect
      height="2"
      width="3"
      fillRule="nonzero"
      fill={color}
      y="9"
      x="10"
      id="Rectangle-2"
    />
    <rect
      height="4"
      width="2"
      fillRule="nonzero"
      fill={color}
      y="11"
      x="11"
      id="Rectangle-3"
    />
    <rect
      height="2"
      width="4"
      fillRule="nonzero"
      fill={color}
      y="15"
      x="10"
      id="Rectangle-4"
    />
  </svg>
);

export default InfoIcon;
